import { render, staticRenderFns } from "./PatientListReg.vue?vue&type=template&id=0bb33306"
import script from "./PatientListReg.vue?vue&type=script&lang=js"
export * from "./PatientListReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports